module.exports = "<header class=\"secondary\"></header>\n<section class=\"mainless\">\n<div class=\"center\">\n  <img [src]=\"logo\" alt=\"Control4 Logo\">\n</div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/splash/splash.component.html
// module id = 1670
// module chunks = 0